import { render, staticRenderFns } from "./DivisionsPage.vue?vue&type=template&id=671d5c04"
import script from "./DivisionsPage.vue?vue&type=script&lang=js"
export * from "./DivisionsPage.vue?vue&type=script&lang=js"
import style0 from "./DivisionsPage.vue?vue&type=style&index=0&id=671d5c04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports